module.exports = __webpack_public_path__ + "img/saudi.a753ce0c.svg";